module.exports = __webpack_public_path__ + "img/ski_sub_title4-5.ce77826f.png";